import { simulatorDownPayment, simulatorIndebtedness, simulatorNotarialCharges } from "../../../../../../../../modules/custom/ev_simulators/js/script";
import { GetDataCalculator } from "../../../modules/calculators/GetDataCalculator";
import { ValidateFields } from "../../../modules/form/ValidateFields";
import { CalculatorService } from "../../services/CalculatorService";
import { getUbicationData } from "../interfaces/UbicationInterface";
import { getUserData } from "../interfaces/UserInterface";
import { getUtmData } from "../interfaces/UtmInterface";
import { getDeviceType } from "../variables/globalVariables";
import { ContactForm } from "./ContactForm";
/**
 * @description Class responsible for handling the form submission.
 */
class CalculatorForm {
    // Constructor where the form state is initialized and methods are bound to the correct context
    constructor(formState) {
        this.formState = formState;
        this.typeForm = '';
        this.formName = '';
        this.ID = 0;
        this.typologyPrice = '';
        this.typologyType = '';
        this.calculos = '';
        this.nameCalculator = '';
        this.financiacion = '';
        // Bind methods to the correct context (this)
        this.submitForm = this.submitForm.bind(this);
        this.setCalculatorForm = this.setCalculatorForm.bind(this);
    }
    getInputValue(form, name) {
        let input = form.querySelector(`[name="${name}"]`);
        if (input && (input.type === "checkbox" || input.type === "radio")) {
            input = form.querySelector(`input[name="${name}"]:checked`);
        }
        return (input === null || input === void 0 ? void 0 : input.value) || '';
    }
    getContextPath() {
        const contextPath = window.location.pathname.split('/')[1] + '/';
        if (document.body.classList.contains('page-node-type-typology')) {
            return '/typology/';
        }
        return contextPath;
    }
    /**
     * Method responsible for submitting the form with the gathered information.
     */
    submitForm(simulatorForm) {
        this.typeForm = simulatorForm ? 'Simulador' : 'Calculadora';
        this.formName = this.formState.manageState('formName');
        this.form = document.querySelector(this.formName);
        simulatorForm ? this.formState.manageState('openCalculator', simulatorForm) : '';
        const validateForm = new ValidateFields(this.formState);
        const readyToSendForm = validateForm.validateSubmitForm(this.form, this.typeForm);
        if (readyToSendForm) {
            // Get form data
            const sendFormUser = new ContactForm(this.formState);
            const userData = getUserData() || sendFormUser.setUserForm(this.form);
            const utmData = getUtmData() || sendFormUser.setUtmForm();
            const ubicationData = getUbicationData();
            const calculatorData = this.setCalculatorForm(this.form);
            const formData = { ...userData, ...calculatorData, ...utmData, ...ubicationData };
            let dataCalculator = new GetDataCalculator(this.formState);
            dataCalculator.showResultsCalculator(formData);
            // Instantiate the service to send the form data
            if (!window.sessionStorage.getItem('simulatorFormSent')) {
                const sendForm = new CalculatorService(this.formState);
                sendForm.sendLead(formData);
            }
            let sidCalculator = window.sessionStorage.getItem('sidCalculator') || "";
            dataCalculator.sendUserDataToAVI(formData, sidCalculator);
        }
    }
    setCalculatorForm(form) {
        var _a, _b;
        if (this.typeForm == 'Simulador') {
            this.typologyPrice = (_a = form.querySelector('[name="propertyPrice"]')) === null || _a === void 0 ? void 0 : _a.value;
        }
        else {
            const contentModal = document.getElementById('calculusModal');
            this.ID = Number(contentModal === null || contentModal === void 0 ? void 0 : contentModal.getAttribute('data-node-id'));
            this.typologyPrice = (contentModal === null || contentModal === void 0 ? void 0 : contentModal.getAttribute('data-house-price')) || '';
            this.typologyType = (contentModal === null || contentModal === void 0 ? void 0 : contentModal.getAttribute('typology-type')) || '';
        }
        const nameOpenCalculator = this.formState.manageState('openCalculator').replace('full-', '') || '';
        const dataCalculator = new GetDataCalculator(this.formState);
        switch (nameOpenCalculator) {
            case 'simulator-subsidy':
                this.nameCalculator = `${this.typeForm} de Subsidio`;
                this.financiacion = 'Subsidio';
                this.calculos = dataCalculator.calculateFormSubsidy();
                break;
            case 'simulator-mortgage':
                this.nameCalculator = `${this.typeForm} Hipotecaria`;
                this.calculos = dataCalculator.calculateFormMortgage(Number(this.getInputValue(form, 'plazo')), 'sendForm');
                break;
            case 'simulator-down-payment':
                this.nameCalculator = `${this.typeForm} Cuota inicial`;
                this.calculos = simulatorDownPayment();
                break;
            case 'simulator-indebtedness':
                this.nameCalculator = `${this.typeForm} de Endeudamiento`;
                this.calculos = simulatorIndebtedness();
                break;
            case 'simulator-notary':
                this.nameCalculator = `${this.typeForm} de Gastos notariales`;
                this.calculos = simulatorNotarialCharges();
                break;
            default:
                this.nameCalculator = 'Calculadora Desconocida';
        }
        const blogSimulator = window.location.pathname.split('/')[1] == 'blog';
        this.nameCalculator = blogSimulator ? 'Blog - ' + this.nameCalculator : this.nameCalculator;
        // Return an object with the extracted form data and context information
        return {
            IngresosFamiliares: this.getInputValue(form, 'ingreso'),
            plazo: nameOpenCalculator != 'simulator-subsidy' ? Number(this.getInputValue(form, 'plazo')) : 0,
            financiacion: nameOpenCalculator != 'simulator-subsidy' ? this.getInputValue(form, 'input_credito') || this.financiacion : '',
            precio: (_b = this.typologyPrice) === null || _b === void 0 ? void 0 : _b.replace(/[\$.]/g, ''),
            project_reference: this.ID,
            contextPath: this.getContextPath(),
            contextDevice: getDeviceType(),
            nameCalculator: this.nameCalculator,
            calculos: this.calculos,
        };
    }
}
// Exporting the class for use in other modules
export { CalculatorForm };
